
function setStore(name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}


function getStore(name) {
  if (!name) return
  return window.localStorage.getItem(name)
}


function removeStore(name) {
  if (!name) return
  window.localStorage.removeItem(name)
}


function setCookie(name, value, day) {
  let date = new Date()
  date.setDate(date.getDate() + day)
  document.cookie = name + '=' + value + ';expires=' + date
};


function getCookie(name) {
  let reg = RegExp(name + '=([^;]+)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return arr[1]
  } else {
    return ''
  }
};


function delCookie(name) {
  setCookie(name, null, -1)
};

function str2Bytes(str) {
  if (str == null || str == '') return null
  let pos = 0
  let len = str.length
  if (len % 2 != 0) return null
  len /= 2
  var hexA = []
  for (let i = 0; i < len; i++) {
    const s = str.substr(pos, 2)
    const v = parseInt(s, 16)
    hexA.push(v)
    pos += 2
  }
  return hexA
}


function bytes2Str(arr) {
  let str = ""
  for (let i = 0; i < arr.length; i++) {
    var tmp = arr[i].toString(16)
    if (tmp.length == 1) tmp = "0" + tmp
    str += tmp
  }
  return str
}


function getBit(str, index) {
  if (str == null || index < 0 || index >= (str.length << 2))
    return false

  const v = parseInt(str[index >> 2], 16)

  return (v & (8 >> (index & 3))) != 0
}


function bits2Str(boolArray) {
  let str = ''

  for (let i = 0, imax = boolArray.length >> 3; i < imax; ++i) {
    const idx = i << 3
    let b = 0
    for (let j = 0; j < 8; ++j)
      if (boolArray[idx + j]) b |= 0x80 >> j
    const s = b.toString(16)
    if (s.length == 1) str += '0'
    str += s
  }

  const surplus = boolArray.length & 7
  if (surplus > 0) {
    const idx = boolArray.length >> 3 << 3
    let b = 0
    for (let j = 0; j < surplus; ++j)
      if (boolArray[idx + j]) b |= 0x80 >> j
    const s = b.toString(16)
    if (s.length == 1) str += '0'
    str += s
  }

  while (str.endsWith('00')) str = str.substr(0, str.length - 2)

  return str
}


function str2Bits(str) {
  const ret = []

  if (!str) return ret

  for (let i = 0, imax = str.length; i < imax; ++i) {
    const v = parseInt(str[i], 16)
    ret.push((v & 8) != 0)
    ret.push((v & 8 >> 1) != 0)
    ret.push((v & 8 >> 2) != 0)
    ret.push((v & 8 >> 3) != 0)
  }

  return ret
}


function trim(str) {
  if (typeof(str) === "string")
    return str.replace(/(^[\s]*)|([\s]*$)/g, "")
  else
    return str
}


const formatPat = /\{(\d+)\}/g
function format(str) {
  if (typeof(str) === "string") {
    var args = arguments
    return str.replace(formatPat, (m, i) => args[i + 1])
  }
  else return str
}


const fmtPat = /\{\}/g
function fmt(str) {
  if (typeof(str) === "string") {
    var args = arguments
    var idx = 1
    return str.replace(fmtPat, m => args[idx++])
  }
  else return str
}

function prefixInteger(num, len) {
  return ("0000000000000000" + num).substr(-len)
}

function formatDate(date) {
  return date instanceof Date ? `${date.getFullYear()}-${prefixInteger(date.getMonth() + 1, 2)}-${prefixInteger(date.getDate(), 2)}` : ''
}

function formatTime(date) {
  return date instanceof Date ? `${prefixInteger(date.getHours(), 2)}:${prefixInteger(date.getMinutes(), 2)}:${prefixInteger(date.getSeconds(), 2)}` : null
}

function formatDateTime(date) {
  return date instanceof Date ? formatDate(date) + " " + formatTime(date) : ''
}

function makeQuery(query) {
  let s = ''
  for (const q in query) {
    const v = query[q]
    if (v != undefined) {
      s += (s ? '&' : '?')
      s += q + '=' + encodeURIComponent(v)
    }
  }
  return s
}

function findValue(dicts, key) {
  if (dicts instanceof Array)
    for (const v of dicts)
      if (key == v.key)
        return v.value
  return key
}

/**
 * 计算请假天数
 */




export default {
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  str2Bytes,
  bytes2Str,
  getBit,
  bits2Str,
  str2Bits,
  trim,
  format,
  fmt,
  prefixInteger,
  formatDate,
  formatTime,
  formatDateTime,
  makeQuery,
  findValue
}



// WEBPACK FOOTER //
// ./src/utils/utils.js